import { FunctionComponent } from 'react';
import Link from 'next/link';
import InsightCard from '@component/InsightCard';
import InsightListWrapper from './insightList.style';
import Pagination from '@component/Pagination';
import InsightsType from '../../types/insights';

type InsightListType = {
  insights: InsightsType[];
  isMobile: boolean;
  insightsTotalCount?: number;
  currentPage?: string;
  visiblePagination?: boolean;
};
const InsightList: FunctionComponent<InsightListType> = ({
  insightsTotalCount = 0,
  insights,
  isMobile,
  currentPage = 1,
  visiblePagination = true,
}) => {
  return (
    <InsightListWrapper>
      <div className="insightlist--items">
        {insights &&
          insights.map((insight) => (
            <Link href={`/insight/${insight.id}`} key={insight.id}>
              <a className="insightlist--item">
                <InsightCard insight={insight} />
              </a>
            </Link>
          ))}
      </div>
      {visiblePagination && (
        <div className="insightlist--pagination">
          <Pagination
            totalCount={insightsTotalCount}
            isMobile={isMobile}
            pageCount={9}
            urlpath="/insight"
            currentPage={isNaN(Number(currentPage)) ? 1 : Number(currentPage)}
          />
        </div>
      )}
    </InsightListWrapper>
  );
};

export default InsightList;
